namespace GeniuzPOS.Supplier {
    export interface CsSupplTypeForm {
        SupplType: Serenity.IntegerEditor;
        SupplTypeName: Serenity.StringEditor;
    }

    export class CsSupplTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Supplier.CsSupplType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsSupplTypeForm.init)  {
                CsSupplTypeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(CsSupplTypeForm, [
                    'SupplType', w0,
                    'SupplTypeName', w1
                ]);
            }
        }
    }
}
